export const useLoader = (elementId = 'ajax_loader', activeClass = 'active') => {
    const element = document.getElementById(elementId);
    const showLoader = () => {
        element?.classList.add(activeClass);
    };

    const hideLoader = () => {
        element?.classList.remove(activeClass);
    };

    return {
        showLoader,
        hideLoader,
    };
};
